export default __webpack_public_path__ + "static/media/time-to-care-this-week-next-week.915b074e.svg";